export default `
    <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container">      
       
     <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <a class="navbar-brand mr-auto" href="#">
        </a>
       

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item active">
                    <a class="nav-link" href="">Home <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#about-us">About Us</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Contact Us</a>
                </li>
                <li class="nav-item pl-lg-5 pl-4">
                    <a class="nav-link" href="whatsapp://send?phone=+919788687886"><span class="icon-whatsapp"></span>+91 97886 87886</a>
                </li>
            </ul>
        </div>
      </div>
    </nav>
`